import yaml from "js-yaml";
import { getLatestVisibilitiesForTopics } from "../services/topicService";

export const extractValidationVariables = (topic, defaultValue = "") => {
  try {
    const validation = topic?.test_configs?.find(
      (config) => config.name === "validation"
    );
    if (validation) {
      if (validation) {
        const variables = validation?.variables;
        return yaml.dump(variables);
      }
    }
  } catch (e) {
    return defaultValue;
  }
};

export const handleTopicVisibilities = async (topics) => {
  const visibilities = await getLatestVisibilitiesForTopics();

  const topicsWithVisibilities = topics.map((topic) => {
    const latest_visibilities = {
      on_demand: null,
      champions: null,
      presentation: null,
    };

    const visibilityKeyMap = {
      "on-demand": "on_demand",
      champions: "champions",
      presentation: "presentation",
    };

    Object.keys(visibilities).forEach((visibilityType) => {
      if (Array.isArray(visibilities[visibilityType])) {
        const topicVisibilities = visibilities[visibilityType].filter(
          (v) => v.topic_key === topic.key
        );

        if (topicVisibilities.length > 0) {
          const latestVisibility = topicVisibilities.reduce((latest, current) =>
            current.version > latest.version ? current : latest
          );

          // Adjust key to match naming convention
          const latestVisibilityKey = visibilityKeyMap[visibilityType];
          latest_visibilities[latestVisibilityKey] = latestVisibility.version;
        }
      }
    });

    return {
      ...topic,
      latest_visibilities,
    };
  });

  const sortedTopics = topicsWithVisibilities.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return sortedTopics;
};
